export default "__VITE_ASSET__08665efd__"